import { passwordValidationPattern } from "@cuauth/user-input-validation-rules";

import { DEFAULT_LOCALE, getMessages, type ValidationMessages } from "@/i18n";

import { PASSWORD_POLICY_ERROR } from "../messages";
import type { ValidationResult } from "../types";

export interface ValidatePasswordOptions {
  email?: string;
  messages?: ValidationMessages;
}

/** Form gate for password fields. Checklist UX lives in requirementStatus.ts. */
export function validatePassword(
  value: string,
  options: ValidatePasswordOptions = {},
): ValidationResult {
  const validationMessages =
    options.messages ?? getMessages(DEFAULT_LOCALE).validation;

  if (!value) {
    return validationMessages.passwordRequired;
  }

  const { email } = options;

  if (email && value.trim().toLowerCase() === email.trim().toLowerCase()) {
    return validationMessages.passwordMatchesEmail;
  }

  if (!passwordValidationPattern.test(value)) {
    return PASSWORD_POLICY_ERROR;
  }

  return true;
}
